module.exports = __webpack_public_path__ + "static/media/SF-UI-Display-Regular.64cb3d89.woff";